export const woodsSpecificationData = [
  {
    id: "foundation_structure",
    title: "Foundation & Structure",
    points: [
      {
        text: "RCC framed structure with red brick/aerocon block/fly ash/solid block masonry.",
      },
    ],
  },
  {
    id: "plastering",
    title: "Plastering",
    points: [
      { label: "Internal", text: "Sand faced cement plaster finish." },
      { label: "External", text: "Double coat cement plastering." },
    ],
  },
  {
    id: "flooring",
    title: "Flooring",
    points: [
      {
        text: "Vitrified tile flooring in foyer, living, family and dining.",
      },
      { text: "Laminated flooring in bedrooms and home theatre." },
      {
        text: "Vitrified/Ceramic tiles for toilet floor and walls up to lintel height.",
      },
      { text: "Anti-skid flooring for balconies." },
      { text: "Ceramic tile flooring with dado for domestic staff room." },
    ],
  },
  {
    id: "toilets",
    title: "Toilets",
    points: [
      { text: "Pressure tested CPVC piping for internal water lines." },
      { text: "PVC piping for internal drain/sewage line and shaft plumbing systems." },
      {
        text: "Water efficient sanitary ware and CP fittings (Kohler / Duravit / Vitra or equivalent).",
      },
      { text: "Granite counter for wash basin in all toilets." },
      { text: "Provision for exhaust fans in toilets." },
    ],
  },
  {
    id: "plumbing_system",
    title: "Plumbing System",
    points: [
      { text: "Hydro-pneumatic water supply system for sufficient pressure." },
      { text: "External sewage plumbing lines." },
      { text: "Water treatment plant and solid waste management system." },
      { text: "Rainwater recharge system." },
      { text: "RO water provision for each villa separately." },
    ],
  },
  {
    id: "doors_windows",
    title: "Doors & Windows",
    points: [
      { label: "Main Door", text: "Teak wood frame and shutter with polyurethane finish." },
      {
        label: "Internal Door",
        text: "Hardwood frame and flush shutter with polyurethane finish.",
      },
      { label: "Door Hardware", text: "Hafele / Yale / Dorma or equivalent." },
      {
        label: "Windows & French Doors",
        text: "UPVC frame with toughened glass (sliding/casement/fixed shutters).",
      },
      {
        label: "Door Stoppers",
        text: "Magnetic/concealed door stoppers for main door and bedrooms.",
      },
    ],
  },
  {
    id: "paint",
    title: "Paint",
    points: [
      {
        label: "External",
        text: "Two coats of acrylic exterior emulsion with texture finish.",
      },
      {
        label: "Internal",
        text: "Two coats of acrylic premium emulsion over smooth putty finish.",
      },
    ],
  },
  {
    id: "electrical_fixture",
    title: "Electrical Fixture",
    points: [
      {
        label: "Wires",
        text: "Fire retardant low smoke wires (Finolex / RR Kabel / Lapp or equivalent).",
      },
      {
        label: "Switches",
        text: "Modular switches (Legrand / Schneider / Panasonic or equivalent).",
      },
      { label: "Power Distribution", text: "Through concealed wiring." },
      { label: "Power Quality", text: "Regulated power with surge suppressors." },
      {
        label: "Backup Power",
        text: "100% DG backup with underground earthing system.",
      },
      {
        label: "Metering",
        text: "Normal and DG power metered through energy meter.",
      },
    ],
  },
  {
    id: "security_network",
    title: "Security Network",
    points: [
      { text: "CCTV cameras in common areas and clubhouse." },
      { text: "Monitoring and recording from security/maintenance room." },
      { text: "Boom barriers with long range readers at entry and exit." },
      { text: "Solar powered security fencing on compound wall." },
    ],
  },
  {
    id: "communication_network",
    title: "Communication Network",
    points: [
      { text: "Telephone points in bedrooms and living area." },
      { text: "Intercom facility throughout the property." },
      { text: "Broadband connectivity in all bedrooms and living area." },
      { text: "TV provision in all bedrooms and living area with DTH connectivity." },
      { text: "Wi-Fi connectivity in clubhouse." },
    ],
  },
  {
    id: "landscaping",
    title: "Landscaping",
    points: [
      { text: "Professionally planned and executed landscape." },
    ],
  },
  {
    id: "elevator",
    title: "Elevator",
    points: [
      { text: "Provision for MRL/Hydraulic lift." },
    ],
  },
];
